import React, { useState, useEffect } from "react";
import "./index.scss";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Pagination, Tooltip } from "@mui/material";
import { getNestedPathValue } from "../../utils/misc2";

const MuiTable = ({
  dataList,
  columnsList =[],
  pageCount,
  onChange,
  filters,
  onClick,
  maxWords,
  customSiRowClass = "",
  showAllFunc,
  customTableClass,
  customTableConClass,
  nestedValue,
}) => {
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (Number.isInteger(parseInt(filters?.page))) {
      setPage(filters.page);
    }
  }, [filters]);
  function truncateWords(text, maxWords) {
    const words = text?.split(" ");
    if (words.length <= maxWords) {
      return text;
    }
    return words.slice(0, maxWords).join(" ") + "...";
  }
  let cumulativeWidth = 0;
  const columnWidths = columnsList.map((col) => {
    const width = col.width || 100;
    const result = { id: col.id, width };
    if (col.freeze) {
      result.left = cumulativeWidth;
      cumulativeWidth += width;
    }
    return result;
  });
  const hasGroupedHeader = columnsList.some((item) => item.columns);

  return (
    <div
      className={`custom-mui-table ${customTableClass ? customTableClass : ""}`}
    >
      <div
        className={`mui-table-with-scroll ${
          customTableConClass ? customTableConClass : ""
        }`}
      >
        <div className={` con-scroll`}>
          <Table sx={{ minWidth: 650 }} stickyHeader size="small">
            <TableHead stickyHeader>
              <TableRow>
                {columnsList?.map((head) => (
                  <TableCell
                    className={`table-con-cell ${customSiRowClass}`}
                    key={head.id}
                    align="center"
                    padding="none"
                    role="checkbox"
                    colSpan={head.columns ? head.columns.length : 1}
                    rowSpan={head.columns ? 1 : 2}
                    style={head?.columns && { borderBottom: "0px" }}
                    sx={
                      head.freeze && {
                        position: "sticky",
                        left: `${
                          columnWidths.find((c) => c.id === head.id).left
                        }px`,
                        background: "white",
                        zIndex: 500,
                      }
                    }
                  >
                    {head.headerRender ? (
                      head.headerRender()
                    ) : (
                      <>
                        {head.freeze ? (
                          <Tooltip title={head.label}>{head.label}</Tooltip>
                        ) : (
                          head.label
                        )}
                      </>
                    )}
                    {head?.columns && (
                      <div className="group-header-border"></div>
                    )}
                  </TableCell>
                ))}
              </TableRow>
              {hasGroupedHeader && (
                <TableRow>
                  {columnsList.map((head) =>
                    head.columns
                      ? head.columns.map((subCol) => (
                          <TableCell
                            key={subCol.id}
                            align="center"
                            className={`sub-table-head-cell`}
                          >
                            {subCol.label}
                          </TableCell>
                        ))
                      : null
                  )}
                </TableRow>
              )}
            </TableHead>
            <TableBody>
              {dataList?.map((ele, mainIndex) => (
                <TableRow
                  key={ele.id ? ele.id : mainIndex}
                  className="mui-table-row"
                >
                  {columnsList?.map((col, index) => {
                    let value = nestedValue
                      ? getNestedPathValue(col.id, ele)
                      : ele[col.id];
                    if (typeof col?.valueConversionLogic === "function") {
                      value = col.valueConversionLogic(value);
                    }
                    if (col.render) {
                      return (
                        <TableCell
                          key={col.id ? col.id : index}
                          align="center"
                          className={`body-table-cell ${customSiRowClass}`}
                          sx={
                            col.freeze && {
                              position: "sticky",
                              left: `${
                                columnWidths.find((c) => c.id === col.id).left
                              }px`,
                              background: "white",
                              // zIndex: 1,
                            }
                          }
                        >
                          {col.render(ele, onClick, index, mainIndex)}
                        </TableCell>
                      );
                    }
                    if (col.columns) {
                      return col.columns.map((subCol) => (
                        <TableCell
                          key={subCol.id || `${index}-${subCol.id}`}
                          align="center"
                          padding="none"
                          className={`body-table-cell ${customSiRowClass}`}
                          // sx={
                          //   col.freeze && {
                          //     position: "sticky",
                          //     left: `${
                          //       columnWidths.find((c) => c.id === col.id).left
                          //     }px`,
                          //     background: "white",
                          //     zIndex: 1,
                          //   }
                          // }
                        >
                          {subCol.render
                            ? subCol.render(ele)
                            : ele[col.id]?.map((item) => (
                                <div key={item._id}>{item[subCol.id]}</div>
                              ))}
                        </TableCell>
                      ));
                    }
                    return (
                      <TableCell
                        key={col.id ? col.id : index}
                        align="center"
                        className={`body-table-cell ${customSiRowClass}`}
                        sx={
                          col.freeze && {
                            position: "sticky",
                            left: `${
                              columnWidths.find((c) => c.id === col.id).left
                            }px`,
                            background: "white",
                            zIndex: 1,
                          }
                        }
                      >
                        {maxWords &&
                        `${value}`?.split(" ").length > maxWords ? (
                          <p className="read-more-text">
                            {truncateWords(value, maxWords)}{" "}
                            <span
                              className="show-more"
                              onClick={() =>
                                showAllFunc({ isOpen: true, text: value })
                              }
                            >
                              Read More
                            </span>
                          </p>
                        ) : (
                          value
                        )}
                        {/* {value} */}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>

      <div className="si-pagination">
        {pageCount > 1 && (
          <Pagination
            page={page}
            count={pageCount}
            className="custom-pagination"
            color="primary"
            onChange={(e, page) => {
              setPage(page);
              if (onChange) {
                onChange(page);
              }
            }}
          ></Pagination>
        )}
      </div>
    </div>
  );
};

export default MuiTable;
